const Slider = new (function () {
  let el;
  let slider;
  let sliderNav;

  this.init = () => {
    const sliderElements = document.querySelectorAll(".keen-slider");
    if (!sliderElements.length) return;

    sliderElements.forEach((el) => {
      slider = new KeenSlider(el, {
        breakpoints: {
          "(min-width: 601px)": {
            slides: {
              perView: 2
            }
          },
          "(min-width: 1024px)": {
            slides: {
              perView: 3
            }
          }
        },
        slides: {
          perView: 1.1
        }
      });

      sliderNav = {
        prev: el
          .closest(".slider-wrapper")
          .querySelector(".sn-slider-nav--prev"),
        next: el
          .closest(".slider-wrapper")
          .querySelector(".sn-slider-nav--next")
      };

      sliderNav.prev.addEventListener("click", slider.prev);
      sliderNav.next.addEventListener("click", slider.next);
    });
  };
})();

export default Slider;
